export default __webpack_public_path__ + "static/media/CNo.79-6.7c87ca5f.jpg";